
import PaidTaskContainer from "../../PaidTask/PaidTaskTable/PaidTaskContainer";
import PageContentContainer from "../../Container/PageContentContainer";

const PaidTaskCollectionPage = () => {
  return (
    <PageContentContainer>
      <PaidTaskContainer displayType={"internalView"} headline={"Übersicht ausgeschriebene Aufgaben"} />
    </PageContentContainer>
  );
};

export default PaidTaskCollectionPage;
